import './PopupNewsletterModal.scss';

import { b2x } from '@b2x/react/src';

import { NewsletterContentType } from '../contentTypes';
import { NewsletterForm } from '../forms/NewsletterForm';

interface PopupNewsletterModalProps extends b2x.ModalProps {}

const PopupNewsletterModal = (modalProps: PopupNewsletterModalProps) => {
  const content = b2x.useContent<NewsletterContentType>('NEWSLETTER_POPUP');

  return (
    <b2x.Modal {...modalProps} className="popup-newsletter-modal">
      <div className="bg-green">
        <b2x.ModalHeader title="" />
        <b2x.ModalBody className="px-3 px-xl-5 text-white">
          <div style={{ marginTop: '-1rem' }}>
            <h1 className="fw-bold text-center">{b2x.formatHtml(content?.body.title)}</h1>
            <div className="text-center p-3 mt-3">
              <div className="mt-3 mb-3 fw-light">{b2x.formatHtml(content?.body.subTitle)}</div>
              <NewsletterForm
                ctaContainerClassName="text-center my-3"
                emailFieldStyle="textInput"
                source="website-modal"
                
              />
            </div>
          </div>
        </b2x.ModalBody>
        {content?.body.asset && (
            <div className="text-center">
              <b2x.AssetV2 {...content.body.asset} fluid />
            </div>
          )}
      </div>
    </b2x.Modal>
  );
};

export const usePopupNewsletterModal = (props?: PopupNewsletterModalProps) =>
  b2x.useStaticModal(PopupNewsletterModal, 'modal', props);
